import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { FieldValue, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import MaskedInput from 'react-text-mask';
import isCpf from '../../../validations/isCpf';

interface ITextFieldCPF<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  onValidityChange?: (isValid: boolean) => void;
  onChange?: (value: string) => void;
}

export function TextFieldCPF<T extends FieldValues>({ form, name, onValidityChange, onChange }: ITextFieldCPF<T>) {
  const {
    register,
    trigger,
    setValue,
    formState: { errors }
  } = form;
  const [cpfValue, setCpfValue] = useState('');
  const getNestedError = (obj: any, path: string) => {
    return path.split('.').reduce((o, key) => o && o[key], obj);
  };
  const fieldError = getNestedError(errors, name);

  useEffect(() => {
    setValue(name, cpfValue as FieldValue<T>, { shouldValidate: false });
  }, [cpfValue, setValue, name]);

  useEffect(() => {
    const isValid = typeof cpfValue !== 'undefined' && isCpf(cpfValue);
    onValidityChange && onValidityChange(isValid);
  }, [cpfValue]);

  return (
    <>
      <MaskedInput
        mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
        className="form-control"
        guide={false}
        id={`input-${name}`}
        value={cpfValue}
        onChange={e => {
          setCpfValue(e.target.value);
          onChange && onChange(e.target.value);
        }}
        onBlur={() => {
          trigger(name);
        }}
        render={(ref, props) => (
          <TextField
            {...props}
            inputRef={ref}
            id={`field-${name}`}
            helperText={fieldError && fieldError.message}
            error={!!fieldError}
            type="tel"
            variant="standard"
            inputProps={{
              maxLength: 14,
              classes: {
                input: 'multilineColor'
              },
              'data-testid': name
            }}
            fullWidth
            placeholder="000.000.000-00"
          />
        )}
      />
      <input
        type="hidden"
        {...register(name, {
          required: {
            value: true,
            message: 'Campo Obrigatório'
          },
          validate: {
            isCpf: value => !value || isCpf(value) || 'CPF inválido'
          },
          pattern: {
            value: /(^\d{3}\x2E\d{3}\x2E\d{3}\x2D\d{2}$)/,
            message: 'CPF inválido'
          }
        })}
      />
    </>
  );
}
